@if (collar()) {
  <div class="collar-specs">
    <div class="collar-specs__details">
      @if (deviceTypeName()) {
        <vectronic-details-item header="Device Type">
          <ng-container>
            {{ deviceTypeName() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collar().comId) {
        <vectronic-details-item header="Com ID">
          <ng-container>
            {{ collar().comId }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collar().comType) {
        <vectronic-details-item header="Com Type">
          <ng-container>
            {{ translateComType(collar().comType) }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (this.adminCollar()?.deviceMetaInformation?.gpsPositionCount) {
        <vectronic-details-item header="Position count">
          <ng-container>
            {{ this.adminCollar().deviceMetaInformation.gpsPositionCount }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (shortrange()) {
        <vectronic-details-item header="Shortrange">
          <ng-container>
            {{ shortrange() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (build()?.antenna) {
        <vectronic-details-item header="Antenna">
          <ng-container>
            {{ build()?.antenna }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (beaconParameter()) {
        <vectronic-details-item header="Beacon">
          <ng-container> {{ formatNumber(beaconParameter()) }} MHz</ng-container>
        </vectronic-details-item>
      }
      @if (pcbType()) {
        <vectronic-details-item header="PCB Type">
          <ng-container>
            {{ pcbType() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (bootloaderVersion()) {
        <vectronic-details-item header="Bootloader">
          <ng-container>
            {{ bootloaderVersion() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (firmwareVersion()) {
        <vectronic-details-item header="Firmware">
          <ng-container>
            {{ firmwareVersion() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (adminCollar().externalDropOffId) {
        <vectronic-details-item header="Drop Off External">
          <ng-container>
            <div
              matTooltip="{{ getDropOffButtonState(isExternalDropOffButtonClickable()).tooltip }}"
              [ngClass]="getDropOffButtonState(isExternalDropOffButtonClickable()).cursorState"
            >
              <button
                mat-button
                (click)="onClickDropOffExternal()"
                [disabled]="getDropOffButtonState(isExternalDropOffButtonClickable()).disabled"
              >
                {{ adminCollar().externalDropOffId }}
                <mat-icon
                  [color]="getDropOffButtonState(isExternalDropOffButtonClickable()).iconColor"
                  >devices_other</mat-icon
                >
              </button>
            </div>
          </ng-container>
        </vectronic-details-item>
      }
      @if (adminCollar().internalDropOffId) {
        <vectronic-details-item header="Drop Off Internal">
          <ng-container>
            <div
              matTooltip="{{ getDropOffButtonState(isInternalDropOffButtonClickable()).tooltip }}"
              [ngClass]="getDropOffButtonState(isInternalDropOffButtonClickable()).cursorState"
            >
              <button
                mat-button
                (click)="onClickDropOffInternal()"
                [disabled]="getDropOffButtonState(isInternalDropOffButtonClickable()).disabled"
              >
                {{ adminCollar().internalDropOffId }}
                <mat-icon
                  [color]="getDropOffButtonState(isInternalDropOffButtonClickable()).iconColor"
                  >devices_other</mat-icon
                >
              </button>
            </div>
          </ng-container>
        </vectronic-details-item>
      }
      @if (build()?.weight) {
        <vectronic-details-item header="Weight">
          <ng-container> {{ build()?.weight }} g</ng-container>
        </vectronic-details-item>
      }
      @if (build()?.housingLabel) {
        <vectronic-details-item header="HousingLabel">
          <ng-container>
            {{ build()?.housingLabel }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (!isBeltEmpty()) {
        <vectronic-details-item header="Belt">
          <button mat-button (click)="onClickBelt()" matTooltip="Belt details">
            {{ belt() }}
            <mat-icon color="accent">merge_type</mat-icon>
          </button>
        </vectronic-details-item>
      }
      @if (batteryType()) {
        <vectronic-details-item header="Battery Type">
          <ng-container>
            {{ batteryType() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (cameraId()) {
        <vectronic-details-item header="Camera">
          <ng-container>
            {{ cameraId() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (vaginalImplantCount()) {
        <vectronic-details-item header="Vaginal Implant">
          <ng-container>
            {{ vaginalImplantCount() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (mortalityImplantCount()) {
        <vectronic-details-item header="Mortality Implant">
          <ng-container>
            {{ mortalityImplantCount() }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (adminCollar().vhfBeaconTransmitterId) {
        <vectronic-details-item header="VHF Beacon Transmitter">
          <ng-container>
            {{ adminCollar().vhfBeaconTransmitterId }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collarLastPositionAltitude()) {
        <vectronic-details-item header="Recent Altitude">
          <ng-container>
            {{ collarLastPositionAltitude()?.toString() + ' m' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collarLastPositionTemperature()) {
        <vectronic-details-item header="Recent Temperature">
          <ng-container>
            {{ collarLastPositionTemperature()?.toString() + ' °C' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collarLastPositionBackupVoltage()) {
        <vectronic-details-item header="Recent Beacon Voltage">
          <ng-container>
            {{ collarLastPositionBackupVoltage()?.toString() + ' V' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (collarLastPositionMainVoltage()) {
        <vectronic-details-item header="Recent Main Voltage">
          <ng-container>
            {{ collarLastPositionMainVoltage()?.toString() + ' V' }}
          </ng-container>
        </vectronic-details-item>
      }
      @if (beaconFrequency()) {
        <vectronic-details-item header="Beacon Frequency">
          <ng-container>
            {{ (beaconFrequency() / 1000000).toFixed(3) + ' MHz' }}
          </ng-container>
        </vectronic-details-item>
      }
    </div>
  </div>
}
